import { render, staticRenderFns } from "./communityteacher.vue?vue&type=template&id=120faaf4&"
import script from "./communityteacher.vue?vue&type=script&lang=js&"
export * from "./communityteacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports